module.exports = __webpack_public_path__ + "static/img/default-img.ed8a4e4f.svg";